import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Tab, Tabs } from '@mui/material';
import SalesOrderSheetPage from '../sales_order_sheet/SalesOrderSheetPage';
import BuysOrderSheetPage from '../buys_order_sheet/BuysOrderSheetPage';

// 2026-10-11 메뉴 재편: 매출/매입 발주서 현황을 "발주서 현황" 한 메뉴 밑 탭으로 합쳤다.
// EstimateStatusPage 와 같은 패턴 — 기존 목록 화면은 그대로, 탭만 ?tab= 으로 기억.
const OrderSheetStatusPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab') === 'buys' ? 'buys' : 'sales';

  const handleChange = (_event, next) => {
    const params = new URLSearchParams(searchParams);
    params.set('tab', next);
    setSearchParams(params);
  };

  return (
    <Box sx={{ width: '100%', minWidth: 0 }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}>
        <Tabs value={tab} onChange={handleChange} aria-label="발주서 현황 탭">
          <Tab value="sales" label="매출 발주서" />
          <Tab value="buys" label="매입 발주서" />
        </Tabs>
      </Box>
      {tab === 'buys' ? <BuysOrderSheetPage /> : <SalesOrderSheetPage />}
    </Box>
  );
};

export default OrderSheetStatusPage;
